
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#373846","d":"M44.045 10.235c-1.248-2.22-2.602-2.628-5.359-2.783-2.754-.187-9.68-.264-15.68-.264-6.012 0-12.94.077-15.692.261-2.751.158-4.108.564-5.368 2.786C.661 12.452 0 16.27 0 22.991v.023c0 6.693.661 10.54 1.946 12.734 1.26 2.22 2.614 2.622 5.365 2.809 2.754.16 9.683.255 15.695.255 6 0 12.926-.094 15.683-.252 2.757-.187 4.111-.59 5.359-2.81C45.344 33.558 46 29.71 46 23.018v-.023c0-6.724-.656-10.542-1.955-12.759zM17.25 31.625v-17.25L31.625 23 17.25 31.625z"}})])
          )
        }
      }
    